"use strict";

// 开发环境导入组件
module.exports = function (file) {
  return require('@/views/' + file + '.vue').default;
}; // vue-loader at least v13.0.0+